import { authFetch, authHeaders, resolveApiBaseUrl } from '../auth';
import { apiUrl } from './http';

export const inventoryMethods = {
  async getLocations() {
    try {
      const base = resolveApiBaseUrl();
      const url = apiUrl(base, 'inventory/locations/');
      const response = await authFetch(url, { method: 'GET', headers: authHeaders({ 'Content-Type': 'application/json' }) });
      if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
      const result = await response.json();
      return { success: result.success !== false, ...result };
    } catch (error) {
      return { success: false, error: error.message, locations: [] };
    }
  },

  async setInventoryLevel({ inventoryItemId, available, locationId } = {}) {
    try {
      const base = resolveApiBaseUrl();
      const url = apiUrl(base, 'inventory/set/');
      const payload = { inventory_item_id: inventoryItemId, available };
      if (locationId) payload.location_id = locationId;
      const response = await authFetch(url, {
        method: 'POST',
        headers: authHeaders({ 'Content-Type': 'application/json' }),
        body: JSON.stringify(payload),
      });
      const result = await response.json().catch(() => ({}));
      if (!response.ok) {
        throw new Error(result.error || `HTTP error! status: ${response.status}`);
      }
      return { success: result.success !== false, ...result };
    } catch (error) {
      return { success: false, error: error.message };
    }
  },

  async getInventoryLevels({ inventoryItemIds, locationId } = {}) {
    try {
      const base = resolveApiBaseUrl();
      const url = apiUrl(base, 'inventory/levels/');
      const payload = { inventory_item_ids: inventoryItemIds || [] };
      if (locationId) payload.location_id = locationId;
      const response = await authFetch(url, {
        method: 'POST',
        headers: authHeaders({ 'Content-Type': 'application/json' }),
        body: JSON.stringify(payload),
      });
      const result = await response.json().catch(() => ({}));
      if (!response.ok) {
        throw new Error(result.error || `HTTP error! status: ${response.status}`);
      }
      return { success: result.success !== false, ...result };
    } catch (error) {
      return { success: false, error: error.message, levels: [] };
    }
  },

  async getInventoryReasons() {
    try {
      const base = resolveApiBaseUrl();
      const url = apiUrl(base, 'inventory/reasons/');
      const response = await authFetch(url, { method: 'GET', headers: authHeaders({ 'Content-Type': 'application/json' }) });
      if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
      const result = await response.json();
      return { success: result.success !== false, ...result };
    } catch (error) {
      return { success: false, error: error.message, reasons: [] };
    }
  },

  async createInventoryAdjustment(payload = {}) {
    try {
      const base = resolveApiBaseUrl();
      const url = apiUrl(base, 'inventory/adjust/');
      const response = await authFetch(url, {
        method: 'POST',
        headers: authHeaders({ 'Content-Type': 'application/json' }),
        body: JSON.stringify(payload),
      });
      const result = await response.json().catch(() => ({}));
      if (!response.ok) throw new Error(result.error || `HTTP error! status: ${response.status}`);
      return { success: result.success !== false, ...result };
    } catch (error) {
      return { success: false, error: error.message };
    }
  },

  async createInventoryAdjustmentsBulk({ rows, locationId, createdBy = 'admin' } = {}) {
    try {
      const base = resolveApiBaseUrl();
      const url = apiUrl(base, 'inventory/adjust/bulk/');
      const payload = { rows: rows || [], created_by: createdBy };
      if (locationId) payload.location_id = locationId;
      const response = await authFetch(url, {
        method: 'POST',
        headers: authHeaders({ 'Content-Type': 'application/json' }),
        body: JSON.stringify(payload),
      });
      const result = await response.json().catch(() => ({}));
      if (!response.ok) throw new Error(result.error || `HTTP error! status: ${response.status}`);
      return { success: result.success !== false, ...result };
    } catch (error) {
      return { success: false, error: error.message, results: [] };
    }
  },

  async getInventoryAdjustments({ inventoryItemId, limit = 100 } = {}) {
    try {
      const base = resolveApiBaseUrl();
      const params = new URLSearchParams();
      if (inventoryItemId) params.set('inventory_item_id', String(inventoryItemId));
      if (limit) params.set('limit', String(limit));
      const url = `${apiUrl(base, 'inventory/adjustments/')}?${params.toString()}`;
      const response = await authFetch(url, { method: 'GET', headers: authHeaders({ 'Content-Type': 'application/json' }) });
      if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
      const result = await response.json();
      return { success: result.success !== false, ...result };
    } catch (error) {
      return { success: false, error: error.message, adjustments: [] };
    }
  }
};
